module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-16-a3230ec05e1acfcfbfd40b07b364317d.jpg";